export const useFilterActiveTargets = (targets) => {
  return targets?.filter(
    (target) => target.status !== 'FINISHED' && target.status !== 'CANCELLED',
  ) || [];
}